import styled from 'styled-components';
import { Flex } from 'UI';

export const PaginationWrapper = styled(Flex)`
  padding: 16px 0px;

  .ant5-pagination {
    border-radius: 3px !important;
    font-family: ${({ theme }) => theme.font.light_14_black_65.family} !important;
    font-size: ${({ theme }) => theme.font.light_14_black_65.size}px !important;
    font-weight: ${({ theme }) => theme.font.light_14_black_65.weight} !important;
    line-height: ${({ theme }) => theme.font.light_14_black_65.lineHeight}px !important;

    color: ${({ theme }) => theme.color.grey35} !important;

    a {
      font-family: ${({ theme }) => theme.font.light_14_black_65.family} !important;
      color: ${({ theme }) => theme.color.grey35} !important;
    }

    span {
      color: ${({ theme }) => theme.color.grey35} !important;
    }

    input {
      border-radius: 3px !important;
    }

    .pagination-jumper-text {
      color: ${({ theme }) => theme.color.brand_black} !important;
      cursor: pointer;
      padding: 0 4px;
      display: inline-block;
      height: 32px;
      min-width: 32px;
      text-align: center;
    }

    .pagination-jumper-text:hover {
      background-color: ${({ theme }) => theme.color.grey_06} !important;
      border-radius: 6px;
    }
  }

  .ant5-pagination-item.ant5-pagination-item-active {
    border-radius: 100% !important;
    background-color: ${({ theme }) => theme.color.brand_black} !important;
    border-color: ${({ theme }) => theme.color.brand_black} !important;

    a {
      color: ${({ theme }) => theme.color.white} !important;
    }
  }
}
`;
